import { render, staticRenderFns } from "./NotaDespacho.vue?vue&type=template&id=2296d020&"
import script from "./NotaDespacho.vue?vue&type=script&lang=js&"
export * from "./NotaDespacho.vue?vue&type=script&lang=js&"
import style0 from "./NotaDespacho.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports